<template>
    <div class="card mb-0" v-if="registration">

        <p class="card-body mt-2" v-if="empty">
            <strong>{{ $t('dashboard.no-simulation') }}</strong>
        </p>

        <div v-if="!empty">

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="preparedSimulations">

                <el-table-column>
                    <template v-slot="{row}">
                        <h3 class="mb-0" :class="{'global':row.isGlobal}">
                            {{ row.name }}
                            <small v-if="row.remedial">
                                <i class="fas fa-undo ml-1"></i>
                            </small>
                        </h3>
                    </template>
                </el-table-column>

                <el-table-column align="center" class-name="competencies" width="160">
                    <template v-slot="{row}">
                        <div :class="{'global':row.isGlobal}">
                            <ratings :data="simulationRatings(row)"
                                v-if="simulationRatings(row)"
                            ></ratings>
                        </div>
                    </template>
                </el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
    import Ratings from '../charts/CompetencyRatings';

    export default {

        components: {
            Ratings,
        },

        props: {

            registration: {
                type: Object,
            },

            simulations: {
                type: Array,
            },

            ratings: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },
        },
        
        computed: {

            empty() {
                return this.simulations.length == 0
            },

            preparedSimulations() {
                let all = [...this.simulations]
                all.unshift({
                    id: 0,
                    isGlobal: true,
                    name: "Global",
                })
                return all
            }
        },

        methods: {
            
            simulationRatings(simulation) {
                return this.ratings[simulation.id] === undefined ? [] : this.ratings[simulation.id]
            },
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding: 1.5rem 0 1.5rem 1.5rem;
        font-size: 0.8rem;
    }
    .card >>> td.competencies {
        padding: 0.3rem 0 0.3rem 0;
    }
    .card >>> td:has(.global) {
        background-color: #f6f9fc !important;
    }

</style>